style= require('./cup-results.styl')

sporty-seasons(
  season=season,
  (change:season)=this.changeSeason(e),
  blank="<select a season>"
)
table
  thead
    tr
      th Total
      th Group
      th Rank
      th Team
      th Goals
      th Against
      th Diff
      th Points
  tbody
    each row in (season && season.tablePositions)
      if row.original && isDifferent(row, row.original)
        tr.row.original
          td.total= row.original.totalRank
          td.group= row.original.group
          td.rank= row.original.rank
          td.name= row.original.name
          td.goals= row.original.goals
          td.against= row.original.against
          td.diff(class=diffClass(row.original.diff))= row.original.diff
          td.points= row.original.points
      tr.row
        td.total
          ft-form-control(
            type="number",
            step="1",
            min="1",
            [(value)]=row.totalRank)
        td.group= row.group
        td.rank
          ft-form-control(
            type="number",
            step="1",
            min="1",
            [(value)]=row.rank)
        td.name= row.name
        td.goals= row.goals
        td.against= row.against
        td.diff(class=diffClass(row.diff))= row.diff
        td.points= row.points
ft-button(
  bloat,
  success,
  (click)=this.save()
) Save
